import React, { useState } from 'react';
import cn from 'classnames';
import styles from './M_AddReaction.module.css';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { useTranslation } from '@/hooks/useTranslation';
import A_Reaction from '@/components/A_Atoms/A_Reaction/A_Reaction';

interface M_AddReactionProps {
  commentObject?: string;
  onActivate?: () => void;
  className?: string;
  onPreviewDragStart?: () => void;
  onPreviewDragEnd?: () => void;
}

export default function M_AddReaction({
  commentObject,
  onActivate,
  className,
  onPreviewDragStart,
  onPreviewDragEnd,
}: M_AddReactionProps) {
  const t = useTranslation();
  const [isActive, setIsActive] = useState(false);

  const handleActivate = () => {
    if (!isActive) {
      setIsActive(true);
      onActivate?.();
    }
  };

  return (
    <div
      className={cn(styles.wrapper, className, { [styles.active]: isActive })}
    >
      {isActive ? (
        <>
          <span className={cn(styles.hint, 'text-p-7')}>
            {t('capsuleReactions.dragAndDrop')}
          </span>
          <A_Reaction
            image={commentObject ?? ''}
            alt={t('capsuleReactions.commentObjectAlt')}
            size='medium'
            className={styles.reactionPreview}
            draggable
            onDragStart={event => {
              event.dataTransfer.effectAllowed = 'copy';
              if (commentObject) {
                event.dataTransfer.setData('text/plain', commentObject);
              }
              onPreviewDragStart?.();
            }}
            onDragEnd={() => {
              onPreviewDragEnd?.();
            }}
          />
        </>
      ) : (
        <A_Button
          variant='primary'
          size='small'
          icon={<Q_Icon.StarIcon width={24} height={24} fill='white' />}
          showIcon
          fontSize='text-p-4'
          onClick={handleActivate}
        >
          {t('capsuleReactions.addReaction')}
        </A_Button>
      )}
    </div>
  );
}
